<template>
<div>
    Loading Test Case...
</div>
</template>

<script>
    import { testService } from "@/service"
    import { applicationState, fieldState, providerState } from "@/state"

    export default  {
        async created() {
            const response = await testService.loadApplyTestCase(this.$route.params.id)
            applicationState.application = response.application
            let to = this.$route.query.to || "/"

            if (response.applyMode) {
                applicationState.applyMode = response.applyMode
                to = to.replace(/\/modes\/(.*?)\//, `/modes/${response.applyMode}/`)
            }

            if (response.fields?.length) {
                fieldState.fields = response.fields
            }

            if (response.providers?.length) {
                providerState.providers = response.providers
            }

            await this.$router.replace(to)
        }
    }
</script>
